module.exports = __webpack_public_path__ + "LBP-Rewards.svg?470388c6a3ac7045810b2c0fd0dbf7bf";